import React from 'react';
import { FieldProps } from 'react-final-form';
import DatePicker from 'components/final-form/DatePicker';

interface DateFieldProps {

  name: string,
  component: any,
  disabledBefore?: Date,
  disabledAfter?: Date,
  disabled?: boolean
}

export const dateInput = (fields: FieldProps): DateFieldProps => {
  return {
    name: fields.name,
    component: DatePicker,
    ...fields
  }
};
